import React, { useState, useEffect } from 'react';
import { AxiosInstance } from '../../../components/utils';
import Spinner from '../../Spinner';

interface NewsItem {
  date: string;
  newscontent: string;
}

const LatestNews: React.FC = () => {
  const [newsItems, setNewsItems] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        const response = await AxiosInstance.get('/api/getnews');
        
        if (response.data && response.data.result === 'Success' && response.data.data) {
          // Transform the news data to the expected format
          const newsData = response.data.data.map((news: any) => ({
            date: news.date,
            newscontent: news.newscontent
          }));

          setNewsItems(newsData);
        } else {
          setNewsItems([]);
        }
      } catch (err) {
        console.error('Error fetching news:', err);
        setError('Failed to load news. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  if (loading) {
    return (
      <section className="card" aria-labelledby="news-coverage">
        <h3 id="news-coverage">Latest News</h3>
        <Spinner />
      </section>
    );
  }

  if (error) {
    return (
      <section className="card" aria-labelledby="news-coverage">
        <h3 id="news-coverage">Latest News</h3>
        <p className="text-danger">{error}</p>
      </section>
    );
  }

  return (
    <section className="card" aria-labelledby="news-coverage">
      <h3 id="news-coverage">Latest News</h3>
      {newsItems.length > 0 ? (
        <ul>
          {newsItems.map((news, index) => (
            <li key={index}>
                <span
        dangerouslySetInnerHTML={{ __html: news.newscontent }}
      />
               
            </li>
          ))}
        </ul>
      ) : (
        <>
        <p>Stay Tuned for Updates on Our Upcoming Quarterly Summit!</p>
        </>
      )}
    </section>
  );
};

export default LatestNews;